import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getLocaleMessages from '../../utils/localesMessages';

const {
	previewContainerText,
} = getLocaleMessages('buttons/wizardStepOne');

const {
	browser
} = getLocaleMessages('buttons/common')

class ImageButtonPreview extends Component {
	static propTypes = {
		buttonImageUrl: PropTypes.string,
		onError: PropTypes.func
	}

	render() {
		if (!this.props.buttonImageUrl) {
			return (
				<div className="buttons img-container">
					<p className="preview-text">{previewContainerText}</p>
				</div>
			);
		}

		return (
			<div className="buttons">
				<img
					src={this.props.buttonImageUrl}
					alt={browser.header}
					onError={(error) => {
						if (this.props.onError) {
							this.props.onError(error);
						}
					}}
				/>
			</div>
		);
	}
}
export default ImageButtonPreview;



// WEBPACK FOOTER //
// ./buttons/components/buttonPreview/ImageButtonPreview.js